import React, {useEffect, useState} from "react";
import bgVideoStyle from "../styles/bgVideo.module.scss";
import {ConfigProvider, Spin} from "antd";
import gsap from "gsap";
import {LocalStorageKey, LocalStorageManagement} from "@/libs/LocalStorage";

export function ProgressiveImage(props: {
    src: string,
    placeholder: string
} & React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>) {
    const [src, setSrc] = React.useState(props.placeholder);
    React.useEffect(() => {
        const timer = setTimeout(() => {
            const img = new Image();
            img.src = props.src;
            img.onload = () => {
                setSrc(props.src);
            };

            // 如果图片是gif格式，则不需要等到onload事件触发
            if (props.src.includes('.gif')) {
                setTimeout(() => {
                    setSrc(props.src);
                }, 3000)
            }

        }, 100);
        return () => {
            clearTimeout(timer)
        }
    }, [props.src]);

    return <img  {...props} src={src}/>;
}

export function BGVideo() {
    const [isLoadingVideo, setIsLoadingVideo] = useState(true);
    const [isNoMask, setIsNoMask] = useState(false);
    const LineVideoNums = 3;
    const LineVideoNumsMobile = 2;

    const animationStart = async () => {
        const videoBoxList = document.getElementsByClassName(`${bgVideoStyle.videoBoxList}`)[0] as HTMLElement;
        const mask = document.getElementsByClassName(`${bgVideoStyle.mask}`)[0] as HTMLElement;
        const videoBoxListTl = gsap.timeline();
        await videoBoxListTl.to(videoBoxList, {duration: 0, ease: 'sine', scale: 4});
        await videoBoxListTl.to(mask, {duration: 1, ease: 'sine', opacity: 0});
        await videoBoxListTl.to(videoBoxList, {duration: 1.5, ease: 'sine', scale: 1});
        new LocalStorageManagement(LocalStorageKey.isAnimationFinished).set('true');
    }


    useEffect(() => {
        // const url = new URL(window.location.href);
        // const search = url.searchParams;
        // const showLogin = search.get('showLogin');
        //
        // if (!new LocalStorageManagement(LocalStorageKey.isAnimationFinished).value && !showLogin && showLogin !== 'false') {
        //     window.location.href = window.location.origin + '/login?showLogin=false';
        //     return;
        // }

        let loadedNums = 0;
        const imgListBox = document.getElementById('img_list') as HTMLElement;
        const imgList = imgListBox.getElementsByTagName('img');
        const listener = () => {
            if (imgList.length) {
                let isTimeOut = false;
                for (let i = 0; i < imgList.length; i++) {
                    imgList[i].onload = () => {
                        loadedNums++;
                        if (loadedNums === imgList.length && !isTimeOut) {
                            isTimeOut = true;
                            setIsLoadingVideo(false);
                            setTimeout(() => {
                                animationStart().then(() => {
                                    setIsNoMask(true);
                                });
                            }, 100)
                        }
                    }
                }

                setTimeout(() => {
                    isTimeOut = true;
                    setIsLoadingVideo(false);
                    setTimeout(() => {
                        animationStart().then(() => {
                            setIsNoMask(true);
                        });
                    }, 100)
                }, 2500)
            }
        }

        if (new LocalStorageManagement(LocalStorageKey.isAnimationFinished).value) {
            // 以前已经加载过了，会有缓存，直接监听图片加载显示
            listener();
        } else {
            // 第一次加载，强行等待3秒
            setTimeout(() => {
                listener();
            }, 3000)
        }



        return () => {
            if (imgList.length) {
                for (let i = 0; i < imgList.length; i++) {
                    imgList[i].onload = null;
                }
            }
        };
    }, []);


    const [isToSmall, setIsToSmall] = useState(false);
    useEffect(() => {
        const targetRatio = 1.78;
        const resize = () => {
            const windowRatio = (Number((window.innerWidth / window.innerHeight * 100).toFixed(2)) as number) / 100;
            setIsToSmall(windowRatio < targetRatio);
        }
        resize();
        window.addEventListener('resize', resize);
        return () => {
            window.removeEventListener('resize', resize);
        };
    }, []);


    const imgDomList = <>
        <div className={bgVideoStyle.videoBoxList + ' ' + (isToSmall ? bgVideoStyle.heightImg : '')}
             id={'gif_list'}>
            <div>
                {
                    Array.from({length: LineVideoNums}).map((_, index) => {
                        return <ProgressiveImage key={index} src={'/video/image' + (1 + index) + '.gif'}
                                                 placeholder={'/video/image' + (1 + index) + '.jpg'} alt={''}/>
                    })
                }
            </div>
            <div>
                {
                    Array.from({length: LineVideoNums}).map((_, index) => {
                        return <ProgressiveImage key={index} src={'/video/image' + (4 + index) + '.gif'}
                                                 placeholder={'/video/image' + (4 + index) + '.jpg'} alt={''}/>
                    })
                }
            </div>
            <div>
                {
                    Array.from({length: LineVideoNums}).map((_, index) => {
                        return <ProgressiveImage key={index} src={'/video/image' + (7 + index) + '.gif'}
                                                 placeholder={'/video/image' + (7 + index) + '.jpg'} alt={''}/>
                    })
                }
            </div>
        </div>
        <div className={bgVideoStyle.mobileVideoList}>
            <div>
                {
                    Array.from({length: LineVideoNumsMobile}).map((_, index) => {
                        return <ProgressiveImage key={index} src={'/video/image' + (1 + index) + '.gif'}
                                                 placeholder={'/video/image' + (1 + index) + '.jpg'} alt={''}/>

                    })
                }
            </div>
            <div>      {
                Array.from({length: LineVideoNumsMobile}).map((_, index) => {
                    return <ProgressiveImage key={index} src={'/video/image' + (3 + index) + '.gif'}
                                             placeholder={'/video/image' + (3 + index) + '.jpg'} alt={''}/>
                })}
            </div>
            <div>
                {
                    Array.from({length: LineVideoNumsMobile}).map((_, index) => {
                        return <ProgressiveImage key={index} src={'/video/image' + (7 + index) + '.gif'}
                                                 placeholder={'/video/image' + (7 + index) + '.jpg'} alt={''}/>
                    })
                }
            </div>
            <div>
                {
                    Array.from({length: LineVideoNumsMobile}).map((_, index) => {
                        return <ProgressiveImage key={index} src={'/video/image' + (5 + index) + '.gif'}
                                                 placeholder={'/video/image' + (5 + index) + '.jpg'} alt={''}/>
                    })
                }
            </div>

            <div>
                <ProgressiveImage src={'/video/image' + 9 + '.gif'} placeholder={'/video/image' + 9 + '.jpg'}/>
                <ProgressiveImage src={'/video/image' + 1 + '.gif'} placeholder={'/video/image' + 1 + '.jpg'}/>
            </div>
            <div>
                {
                    Array.from({length: LineVideoNumsMobile}).map((_, index) => {
                        return <ProgressiveImage key={index} src={'/video/image' + (4 + index) + '.gif'}
                                                 placeholder={'/video/image' + (4 + index) + '.jpg'} alt={''}/>
                    })
                }
            </div>
        </div>
    </>


    return <>
        {
            isLoadingVideo ? <div className={bgVideoStyle.loadingBg}>
                    <div className={bgVideoStyle.soraAiLogoBox}>
                        <ConfigProvider theme={{
                            token: {
                                colorPrimary: 'white',
                                borderRadius: 0,
                            },
                        }}>
                            <Spin size={'large'}/>
                        </ConfigProvider>
                        <img alt={''} src={'/img/SoraAi.png'}/>
                    </div>
                    <div style={{display: 'none'}} id={'img_list'}>
                        {imgDomList}
                    </div>
                </div> :
                <>
                    <div className={bgVideoStyle.bg}>
                        <div className={bgVideoStyle.videoBox}>
                            {imgDomList}
                            <div className={bgVideoStyle.BgVideoMask}/>
                        </div>
                    </div>
                    {isNoMask ? <></> : <div className={bgVideoStyle.mask}></div>}
                </>
        }
    </>
}